import { render, staticRenderFns } from "./Hero-Section.vue?vue&type=template&id=f484e468&scoped=true"
import script from "./Hero-Section.vue?vue&type=script&lang=js"
export * from "./Hero-Section.vue?vue&type=script&lang=js"
import style0 from "./Hero-Section.vue?vue&type=style&index=0&id=f484e468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f484e468",
  null
  
)

export default component.exports